import { render, staticRenderFns } from "./TopicProgress.vue?vue&type=template&id=66fe42d7&scoped=true&"
import script from "./TopicProgress.vue?vue&type=script&lang=js&"
export * from "./TopicProgress.vue?vue&type=script&lang=js&"
import style0 from "./TopicProgress.vue?vue&type=style&index=0&id=66fe42d7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66fe42d7",
  null
  
)

export default component.exports